<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return{
      devToolsTimer: null,
    }
  },
  mounted() {
    //首先我们获得视口高度并将其乘以1%以获得1vh单位的值
    let vh = window.innerHeight * 0.01
    // 然后，我们将——vh自定义属性中的值设置为文档的根
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    // 我们监听resize事件 视图大小发生变化就重新计算1vh的值
    window.addEventListener('resize', () => {
      // 我们执行与前面相同的脚本
      let vh = window.innerHeight * 0.01
      console.log(vh);
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    })

    if(process.env.NODE_ENV === 'production'){
      // 禁止 F12 / Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+U
      document.addEventListener('keydown', (e) => {
        if (
            e.key === 'F12' ||
            (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key)) ||
            (e.ctrlKey && e.key === 'U')
        ) {
          e.preventDefault()
        }
      })

      // 禁止右键
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault()
      })

      // 检测开发者工具
      this.startDetect()

      // 页面可见性监听
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      // 关键：监听返回缓存恢复
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          window.location.reload()
        }
      })
    }
  },
  methods: {
    startDetect() {
      const threshold = 160

      this.devToolsTimer = setInterval(() => {
        const widthDiff = window.outerWidth - window.innerWidth
        const heightDiff = window.outerHeight - window.innerHeight

        if (widthDiff > threshold || heightDiff > threshold) {
          this.forceClose()
        }

        // 2. debugger 判断
        const start = performance.now()
        debugger
        const end = performance.now()
        if (end - start > 100) {
          this.forceClose()
        }
      }, 2000)
    },

    handleVisibilityChange() {
      if (document.hidden) {
        // 页面失焦，停止检测
        clearInterval(this.devToolsTimer)
        this.devToolsTimer = null
      } else {
        // 页面重新聚焦，恢复检测
        if (!this.devToolsTimer) {
          this.startDetect()
        }
      }
    },
    forceClose() {
      document.body.innerHTML = ''
      location.href = 'about:blank'
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  box-sizing: border-box;
}
</style>
